var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16","width":"16","height":"16"}},[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M8 3.333v9.334M3.333 8h9.334"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }